import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { EmailOutlined, PhoneIphone, ArrowBack } from "@material-ui/icons";
import renderHTML from "react-render-html";
import TextareaAutosize from "react-textarea-autosize";
import moment from "moment";
import { toastMessage } from "./../../../Common/Common";
import $ from "jquery";
import * as code from "./../../../../config/Constants";
import * as message from "./../../../../config/CommonMessages";

var _ = require("lodash");

class DiscussionDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msgContent: "",
      type: "TEXT",
      errMsg: "",
    };
  }

  componentDidMount() {
    setTimeout(function() {
      $(".discussion-detail-inner").scrollTop(
        $(".discussion-detail-inner-height").outerHeight()
      );
    }, 1);
  }

  componentWillReceiveProps() {
    setTimeout(function() {
      $(".discussion-detail-inner").scrollTop(
        $(".discussion-detail-inner-height").outerHeight()
      );
    }, 1);
  }

  backList = () => {
    this.props.DiscussionDetailMethod(1);
  };

  setMsgContent(e) {
    let msgContent = e.target.value;
    this.setState({ msgContent });
  }

  /**
   * @desc send replay button action - send data to parent component to call api
   */
  sendReply() {
    let msgContent = this.state.msgContent;
    let threadObj = this.props.threadObj;
    let type = threadObj.mobileNumber !== undefined ? "TEXT" : "EMAIL";

    //show error msg if type = EMAIL
    if (type == "EMAIL") {
      this.setState({ errMsg: "Can not reply as there is no phone number." });
      return false;
    }

    if (msgContent !== "") {
      this.props.sendReply(msgContent, threadObj, type).then((res) => {
        if (res.status) {
          this.setState({ msgContent: "" });
          setTimeout(function() {
            $(".discussion-detail-inner").scrollTop(
              $(".discussion-detail-inner-height").outerHeight()
            );
          }, 1);
        }
      });
    }
  }

  /**
   * @desc resend msg function - not in use as per current requirement
   * @param {*} discussionId
   */
  resendMsg(discussionId) {
    let threadObj = this.props.threadObj;
    this.props.resendMsg(discussionId, threadObj);
  }
  newLineText(desc) {
    let newText = desc.replaceAll("\n", "<br />");
    return newText;
  }

  render() {
    //sort messages by date
    let messagesList = _.sortBy(this.props.messages, "receiveTime");

    //Group by messages by date
    let messages = _.groupBy(messagesList, function(b) {
      if (
        b.receiveTime !== null &&
        b.receiveTime !== "" &&
        b.receiveTime !== undefined
      ) {
        return moment(b.receiveTime).format("YYYY-MM-DD");
      } else {
        return "";
      }
    });
    let threadContactMob = "";
    let threadContactEmail = "";

    if (this.props.threadObj !== undefined) {
      threadContactMob = this.props.threadObj.mobileNumber;
      if (this.props.threadObj.email !== undefined) {
        threadContactEmail = this.props.threadObj.email.address;
      }
    }

    return (
      <div className="discussion-detail">
        <div className="discussion-detail-title d-flex align-items-center">
          <h4 className="font-16 color-grey-1 mb-0 pl-3">
            <Button
              variant="link"
              className="p-0 pr-1 color-grey-1 chat-back"
              onClick={this.backList}
            >
              <ArrowBack />
            </Button>
            {this.props.name}
          </h4>
        </div>
        <div className="discussion-detail-inner">
          <div className="discussion-detail-inner-height">
            {Object.keys(messages).map((key) => (
              <>
                {key != "" && (
                  <>
                    <div className="chat-day">
                      <span>
                        {/* Show format like Today, Yesterday, and date */}
                        {moment(key).format("MM/DD/YYYY") ==
                        moment().format("MM/DD/YYYY")
                          ? "Today"
                          : moment(key).format("MM/DD/YYYY") ==
                            moment()
                              .subtract(+1, "days")
                              .format("MM/DD/YYYY")
                          ? "Yesterday"
                          : moment(key).format("MM/DD/YYYY")}
                      </span>
                    </div>

                    {messages[key].map((e, i) => {
                      return (
                        <div
                          key={"msg-" + i}
                          className={
                            (threadContactMob !== "" &&
                              e.from == threadContactMob) ||
                            (threadContactEmail !== "" &&
                              e.from == threadContactEmail)
                              ? "chat-bubble"
                              : "chat-bubble chat-me"
                          }
                        >
                          <div className="chat-bubble-contain">
                            <div className="chat-bubble-inner">
                              <p className="color-grey-1 font-14 mb-0">
                                {!!e.description && e.description !== undefined
                                  ? e.communicationType === "EMAIL"
                                    ? renderHTML(e.description)
                                    : renderHTML(
                                        this.newLineText(e.description)
                                      )
                                  : ""}
                              </p>
                              <Row className="mx-0 align-items-center">
                                <Col className="px-0">
                                  {e.communicationType == "TEXT" ? (
                                    <PhoneIphone className="card-type" />
                                  ) : (
                                    <EmailOutlined className="card-type" />
                                  )}
                                </Col>
                                <Col className="px-0 font-12 color-grey-1 text-right">
                                  {e.receiveTime !== null
                                    ? moment(e.receiveTime).format("hh:mm A")
                                    : ""}
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </>
                )}
              </>
            ))}
          </div>
        </div>

        <div className="discussion-detail-outer">
          <Row className="mx-0 align-items-center">
            <Col className="px-0">
              <TextareaAutosize
                maxRows={3}
                className="form-control"
                placeholder="Write reply here..."
                onChange={(e) => this.setMsgContent(e)}
                value={this.state.msgContent}
              />
              <div className="invalid-feedback" style={{ display: "block" }}>
                {this.state.errMsg}
              </div>
            </Col>
            <Col className="col-auto pr-0 pl-3">
              <Button
                variant="primary"
                className="btn-blue w-90 send-rply"
                onClick={(e) => {
                  // if (localStorage.getItem("isActive") === "false") {
                  //   toastMessage(code.ERROR, message.SUBSCRIPTION_NOT_ACTIVE);
                  // } else if (this.props.transactionData.status == "CANCELED") {
                  //   toastMessage(code.ERROR, message.TRANSACTION_CANCELED);
                  // } else {
                  //   this.sendReply();
                  // }

                  this.sendReply();
                }}
              >
                Send
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default DiscussionDetail;
